import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState, selectFeature } from './item-data.reducer';
import { EntityDataStore } from '../entity-data/entity-data.store';
import { Item } from './item.model';

@Injectable()
export class ItemDataStore extends EntityDataStore<IState, Item> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }
}
